import { useState } from "react";

//Whenever a new search is initiated we neewd top reset the grid data state
//This hook will handle this processing in a consistent manner
//We need to track when a new search is initiated and when the grid data state needs to be reset
//then we need to identify when the grid data state has been reset

export default function useGridDataStateResetProcessing() {
  const [
    gridDataStateResetProcessingInitiated,
    setGridDataStateResetProcessingInitiated,
  ] = useState(false);

  function InitiateGridDataStateReset() {
    setGridDataStateResetProcessingInitiated(true);
  }

  //expose a function to identify that the reset has been completed
  function GridDataStateResetCompleted() {
    setGridDataStateResetProcessingInitiated(false);
  }

  return {
    gridDataStateResetProcessingInitiated,
    InitiateGridDataStateReset,
    GridDataStateResetCompleted,
  };
}
